import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import SEO from "@/components/SEO";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      const target = sessionStorage.getItem("auth:redirect") ?? "/";
      sessionStorage.removeItem("auth:redirect");
      navigate(target, { replace: true });
    };

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const errorDescription = params.get("error_description") ?? new URLSearchParams(window.location.search).get("error_description");
    if (errorDescription) {
      setError(errorDescription);
      return;
    }

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) finish();
    });

    supabase.auth.getSession().then(({ data }) => {
      if (data.session) finish();
      else setTimeout(() => { if (!done) navigate("/acceso", { replace: true }); }, 3000);
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <>
      <SEO title={t("auth.callbackTitle")} description={t("auth.callbackSeoDescription")} noindex />
      <main className="flex min-h-screen items-center justify-center bg-background px-6">
        <div className="max-w-sm space-y-4 text-center">
          {error ? (
            <>
              <h1 className="font-serif text-2xl text-foreground">{t("auth.errorTitle")}</h1>
              <p className="text-muted-foreground">{error}</p>
            </>
          ) : (
            <>
              <Loader2 className="mx-auto h-6 w-6 animate-spin text-primary" aria-hidden="true" />
              <p className="text-muted-foreground">{t("auth.callbackText")}</p>
            </>
          )}
        </div>
      </main>
    </>
  );
};

export default AuthCallback;
